import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DashboardHeader from '../../components/DashboardHeader';
import DashboardFooter from '../../components/DashboardFooter';

const useStyles = makeStyles(() => ({
  wrapper: {
    paddingRight: '10%',
    paddingLeft: '10%',
    paddingTop: '50px'
  },
}));

export default function PastInitiativeLayout({children}) {
  const classes = useStyles();
  const createMenus = (path, name) => {
    return {path, name};
  };

  const menus = [
    createMenus('/ui/past/initiatives', 'My Initiatives'),
    createMenus('/ui/past/myteam', 'My Team'),
    createMenus('/ui/transalta', 'TransAlta Report'),
  ];

  return (
    <div id="body-container">
      <DashboardHeader menus={menus}/>
      <div className={classes.wrapper}>
        {children}
      </div>
      <DashboardFooter />
    </div>
  );
}